import styled from 'styled-components'
import { font } from 'lib/core/resources/helpers/styled'

export const PaginationStyles = styled.div`
  ul {
    display: flex;
    margin: 0;
    padding: 0;
    list-style: none;
  }

  li {
    margin: 2px;

    &:first-child {
      margin-left: 0;
    }

    &:last-child {
      margin-left: 0;
    }
  }

  a {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    line-height: 1;
    color: ${props => props.theme.palette.general.strong};
    text-decoration: none;
    width: 30px;
    height: 30px;
    background: ${props => props.theme.palette.general.light};
    border: 1px solid ${props => props.theme.palette.general.greyLight};
  }

  li.active {
    a {
      font: ${font('default', 'bold', '14px/1')};
    }
  }
`

export const PaginationWrapper = styled.div`
  width: 100%;

  .pagination {
    padding: 0;
    list-style: none;
    display: flex;
    align-items: center;
    justify-content: center;

    li {
      margin: 0 4px;

      a {
        padding: 5px 12px;
        display: flex;
        align-items: center;
        text-decoration: none;
        color: ${props => props.theme.palette.general.strong};
        border-bottom: 4px solid transparent;
      }

      &.active {
        a {
          color: ${props => props.theme.palette.primary.alphaDark};
          border-bottom-color: ${props => props.theme.palette.primary.alphaDark};
        }
      }
    }
  }

  svg {
    width: 18px;
    height: 18px;
  }
`
